import React, { useEffect, useRef, useState } from 'react';
import CountUp from 'react-countup';
import './AboutUsFactSection.css';
import teampic from '../../assets/team/about-us-team.svg';

const AboutUsFactSection = () => {
  const numberRef = useRef(null);
  const barRef = useRef(null);

  const [showNumbers, setShowNumbers] = useState(false);
  const [showBars, setShowBars] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowNumbers(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    if (numberRef.current) observer.observe(numberRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowBars(true);
          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );
    if (barRef.current) observer.observe(barRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="rpa-section-about-us-page">
      <div className="rpa-container">
        <h2 className="rpa-title">Unsere Erfahrung & Vorteile</h2>
        <div className="rpa-content">
          {/* Text Left */}
          <div className="rpa-left">
            <div className="stats-container" ref={numberRef}>
              <div className="stat-box">
                <span className="stat-number">
                  {showNumbers && <CountUp end={7} duration={5} />}+
                </span>
                <p>Jahre Erfahrung</p>
              </div>
              <div className="stat-box">
                <span className="stat-number">
                  {showNumbers && <CountUp end={4} duration={5} />}+
                </span>
                <p>Projekte in Planung</p>
              </div>
              <div className="stat-box">
                <span className="stat-number">
                  {showNumbers && <CountUp end={5} duration={5} />}+
                </span>
                <p>Mitarbeiter</p>
              </div>
            </div>

            <div className="advantage-section" ref={barRef}>
              <h3 className="rpa-heading">Unsere Vorteile durch Near Shoring</h3>

              <div className="bar-container">
                <div className="bar-label">30% Kostenreduktion</div>
                <div className="bar-background">
                  <div className={`bar-fill ${showBars ? 'short animate' : ''}`}></div>
                </div>
              </div>

              <div className="bar-container">
                <div className="bar-label">100% fristgerechte Fertigstellung</div>
                <div className="bar-background">
                  <div className={`bar-fill ${showBars ? 'full animate' : ''}`}></div>
                </div>
              </div>

              <div className="bar-container">
                <div className="bar-label">60% Höhere Umsetzung</div>
                <div className="bar-background">
                  <div className={`bar-fill ${showBars ? 'sixty animate' : ''}`}></div>
                </div>
              </div>
            </div>
          </div>

          {/* Image Right */}
          <div className="rpa-right-about-us-page fade-in">
            <img src={teampic} alt="Team" className="rpa-image-about-us-page" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsFactSection;
